module.exports = __webpack_public_path__ + "static/media/spaced-repetition-sub.58b911d1.png";